export default __webpack_public_path__ + "static/media/upload.8d22aa26.svg";